import React from 'react'

import {PageTitle} from '../../components';

import Layout from '../../components/about/Layout';


export default () => (
  <Layout>
    <PageTitle title='优势价值'/>
  </Layout>
)


// WEBPACK FOOTER //
// ./src/pages/about/worth.js